export const ADMIN_ROLE = 'admin_referensiel'
export const COACH_ROLE = 'coach'

export const staffLanguagesCode = ['es', 'fr', 'en']

export const TYPE_EMAIL_INACTIVITY = 'inactivity_email'
